import { BrowserRouter } from 'react-router-dom';
import { Suspense } from 'react';
import { AppRoutes } from './router';
import { ShopifyProvider } from './context/ShopifyContext';
import { WishlistProvider } from './context/WishlistContext';
import { AuthProvider } from './context/AuthContext';
import { WishlistDrawer } from './components/WishlistDrawer';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <ShopifyProvider>
          <WishlistProvider>
            <Suspense fallback={<div className="min-h-screen bg-[#0A0A0A]" />}>
              <AppRoutes />
            </Suspense>
            <WishlistDrawer />
          </WishlistProvider>
        </ShopifyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
